import React from "react";
import { Text as RNText } from "react-native";
import { getVariants } from "@utils/styles";

const getVariantStyle = (variant, newfont) => getVariants(variant, newfont);

const CustomText = (props) => {
  const { variant, children, style, newfont = false, ...rest } = props;
  return (
    <RNText
      style={[getVariantStyle(variant ?? "blank", newfont), style]}
      {...rest}
    >
      {children}
    </RNText>
  );
};

export default CustomText;
